import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { useParams } from 'react-router-dom';
import Loading from '../ui/Loading';
import { fetchArticleDetails } from '../../features/admin/articleSlice';

const ArticleDetails = () => {
    const { articleId } = useParams<{ articleId: string }>();
    const dispatch = useDispatch<AppDispatch>();
    const { article, loading } = useSelector((state: RootState) => state.articleSlice);


    useEffect(() => {
        if (articleId) {
            dispatch(fetchArticleDetails({ articleId: Number(articleId) }));
        }
    }, [dispatch, articleId]);

    if (loading) {
        return <Loading />;
    }

    return (
        <div className="">
            {/* صورة المقال */}
            <img
                src={article?.image}
                alt={article?.title}
                className=" w-full max-h-[450px] object-cover mb-6"
            />
            <div className=' padding-container'>
                <div className=' flex-between border-b'>
                    <div>
                        <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3 leading-relaxed">
                            {article?.title}
                        </h1>
                        <div className="mb-6 text-sm text-gray-500">
                            {article?.country} 
                        </div>
                    </div>
                    <div>
                        <div dir='ltr' className="flex  flex-col text-sm text-gray-500  pb-2 mb-4">
                            <p className="text-primary font-semibold"> <span className="text-textSecond">By:</span> LiBooking Team</p>
                            <span>
                                {article?.createAt ? new Date(article.createAt).toLocaleString() : ''}
                            </span>
                        </div>
                    </div>
                </div>
                <p className="text-lg font-semibold my-6">{article?.subTitle}</p>
                <div className="text-textSecond mb-6 leading-loose whitespace-pre-line">
                    {article?.details}
                </div>
            </div>

        </div>
    );
};

export default ArticleDetails;
